var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 11.6666H10.8333C11.2754 11.6666 11.6993 11.491 12.0118 11.1784C12.3244 10.8659 12.5 10.4419 12.5 9.99992C12.5 9.55789 12.3244 9.13397 12.0118 8.82141C11.6993 8.50885 11.2754 8.33325 10.8333 8.33325H8.33333C7.83333 8.33325 7.41667 8.49992 7.16667 8.83325L2.5 13.3333",
    stroke: "#DB2777",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 16.6667L7.16634 15.5001C7.41634 15.1667 7.83301 15.0001 8.33301 15.0001H11.6663C12.583 15.0001 13.4163 14.6667 13.9997 14.0001L17.833 10.3334C18.1546 10.0295 18.3423 9.61031 18.3548 9.16804C18.3673 8.72576 18.2036 8.29664 17.8997 7.97506C17.5958 7.65349 17.1766 7.46581 16.7343 7.4533C16.292 7.4408 15.8629 7.6045 15.5413 7.9084L12.0413 11.1584",
    stroke: "#DB2777",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 12.5L6.66699 17.5",
    stroke: "#DB2777",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 7.08333C16.8333 6.5 17.5 5.75 17.5 4.83333C17.5582 4.32411 17.4428 3.81013 17.1724 3.3747C16.902 2.93927 16.4925 2.6079 16.0103 2.43429C15.528 2.26068 15.0013 2.255 14.5154 2.41818C14.0295 2.58136 13.613 2.90383 13.3333 3.33333C13.0358 2.93715 12.6192 2.64677 12.1445 2.50482C11.6698 2.36287 11.1622 2.37682 10.696 2.54464C10.2299 2.71245 9.82981 3.02528 9.55455 3.4372C9.27928 3.84913 9.14332 4.33845 9.16663 4.83333C9.16663 5.83333 9.83329 6.5 10.4166 7.16667L13.3333 10L16.25 7.08333Z",
    stroke: "#DB2777",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.ff173d4c7462e3dd6c43bb0f9b02c081.svg";
export { ForwardRef as ReactComponent };